import React, { useState, useEffect } from 'react';
import {
    Box, Typography, IconButton, Modal, Grid, TextField, Button, List, ListItem, ListItemText, Paper, Checkbox,
    FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';

// Definir a base URL da API
const apiBaseURL = 'https://plasticemployers.duckdns.org';  

axios.defaults.baseURL = apiBaseURL;
axios.defaults.withCredentials = true;

const Home = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const [openDivisionModal, setOpenDivisionModal] = useState(false);
    const [openAddDivisionModal, setOpenAddDivisionModal] = useState(false);
    const [openPermissionsModal, setOpenPermissionsModal] = useState(false);
    const [newDivision, setNewDivision] = useState('');
    const [divisions, setDivisions] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState(null);
    const [users, setUsers] = useState([]);
    const [devices, setDevices] = useState([]);
    const [integrations, setIntegrations] = useState([]);
    const [openAddDeviceModal, setOpenAddDeviceModal] = useState(false);
    const [homeAssistantDevices, setHomeAssistantDevices] = useState([]); // Dispositivos do Home Assistant
    const [selectedDevice, setSelectedDevice] = useState(null); // Dispositivo selecionado para adicionar
    const [openAddIntegrationModal, setOpenAddIntegrationModal] = useState(false); // Controle da modal de integração
    const [selectedIntegrationType, setSelectedIntegrationType] = useState(''); // Tipo de integração selecionado
    const [selectedDays, setSelectedDays] = useState([]); // Dias selecionados
    const [toggleOnTime, setToggleOnTime] = useState(''); // Hora de ligar
    const [toggleOffTime, setToggleOffTime] = useState(''); // Hora de desligar


    // Buscar divisões e usuários da API
    useEffect(() => {

        const token = localStorage.getItem('access');
            if (!token) {
                console.error('Token JWT não encontrado.');
            } else {
                console.log('Token JWT encontrado:', token);
            }
            
        fetchDivisions();
        fetchUsers();
    }, []);

    const handleSaveIntegration = async () => {
        if (!selectedDevice) return;
    
        try {
            const payload = {
                name: `Ligar/Desligar Dispositivo (${selectedDevice.friendly_name || selectedDevice.entity_id})`,
                config: {
                    device_id: selectedDevice.entity_id,
                    days: selectedDays,
                    on_time: toggleOnTime,
                    off_time: toggleOffTime,
                },
            };
            await axios.post(`/api/integrations/${selectedDivision.id}/create/`, payload);
            fetchIntegrations(selectedDivision.id); // Atualize a lista
            setOpenAddIntegrationModal(false); // Feche a modal
        } catch (error) {
            console.error('Erro ao salvar integração:', error);
        }
    };
    

    const fetchDevices = async (divisionId) => {
        try {
            const response = await axios.get(`/api/devices/${divisionId}`);
            setDevices(response.data);
        } catch (error) {
            console.error('Erro ao buscar dispositivos:', error);
        }
    };

    const toggleDeviceState = async (device) => {
        const newState = device.state === 'on' ? 'off' : 'on';
        try {
            await axios.post(`/api/homeassistant/toggle/`, {
                entity_id: device.entity_id,
                state: newState,
            });
            // Atualize o estado local após alternar
            setDevices((prevDevices) =>
                prevDevices.map((d) =>
                    d.id === device.id ? { ...d, state: newState } : d
                )
            );
        } catch (error) {
            console.error('Erro ao alternar o estado do dispositivo:', error);
        }
    };


    

    

    const fetchHomeAssistantDevices = async () => {
        
        let token = localStorage.getItem('TUser');
if (!token) {
    console.error('Token não encontrado no localStorage');
}
    
        try {
            const response = await axios.get('/api/devices/', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setHomeAssistantDevices(response.data);
        } catch (error) {
            
                console.error('Erro ao buscar dispositivos do Home Assistant:', error);
            
        }
    };
    
    const handleAddDevice = async () => {
        if (!selectedDevice) return;
    
        try {
            const payload = {
                division_id: selectedDivision.id,
                entity_id: selectedDevice.entity_id,
                friendly_name: selectedDevice.attributes.friendly_name,
                state: selectedDevice.state,
                attributes: selectedDevice.attributes,
            };
            const response = await axios.post('/api/devices/add/', payload);
            console.log(response.data);
            setOpenAddDeviceModal(false); // Fechar a modal após adicionar o dispositivo
            fetchDevices(selectedDivision.id); // Atualizar dispositivos da divisão
        } catch (error) {
            console.error('Erro ao adicionar dispositivo à divisão:', error);
        }
    };
    
    const fetchIntegrations = async (divisionId) => {
        try {
            const response = await axios.get(`/api/integrations/${divisionId}`);
            setIntegrations(response.data);
        } catch (error) {
            console.error('Erro ao buscar integrações:', error);
        }
    };

    const handleOpenDivisionModal = (division) => {
        setSelectedDivision(division);
        fetchDevices(division.id); // Carregar dispositivos da divisão
        fetchIntegrations(division.id); // Carregar integrações da divisão
        setOpenDivisionModal(true);
    };

    

    const fetchUsers = async () => {
        try {
            const response = await axios.get('/api/users/');
            setUsers(response.data);
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
        }
    };

    const fetchDivisions = async () => {
        try {
            const response = await axios.get('/api/divisions/');
            const allDivisions = response.data;
    
            console.log('Usuário logado:', user); // Exibe os dados do usuário logado no console
            console.log('ID do usuário logado:', user.id); // Mostra o ID específico do usuário logado
    
            // Filtrar divisões baseadas nas permissões do usuário
            if (user.seccao === 'Admin') {
                setDivisions(allDivisions); // Admins podem ver todas as divisões
            } else {
                const userPermissionsResponse = await axios.get('/api/permissions/');
                const userPermissions = userPermissionsResponse.data;
                console.log('Permissões do usuário:', userPermissions);
    
                // Verifique se userPermissions contém division_id e empregado_id
                const accessibleDivisions = allDivisions.filter((division) =>
                    userPermissions.some((permission) => {
                        console.log(
                            `Comparando divisão ${division.id} com permissão ${permission.division_id} e empregado ${permission.empregado_id}`
                        );
                        return (
                            permission.division_id === division.id &&
                            permission.empregado_id === user.id
                        );
                    })
                );
    
                console.log('Divisões acessíveis ao usuário:', accessibleDivisions);
                setDivisions(accessibleDivisions);
            }
        } catch (error) {
            console.error('Erro ao buscar divisões:', error);
        }
    };
    const handleDeleteDivision = async (divisionId) => {
        try {
            await axios.delete(`/api/divisions/${divisionId}/`);
            fetchDivisions(); // Atualizar divisões
        } catch (error) {
            console.error('Erro ao deletar divisão:', error);
        }
    };
    
    
    

    const handleCloseDivisionModal = () => setOpenDivisionModal(false);

    const handleOpenPermissionsModal = (division) => {
        setSelectedDivision(division);
        setSelectedPermissions(division.permissions || []);
        setOpenPermissionsModal(true);
    };

    const handleClosePermissionsModal = () => {
        setOpenPermissionsModal(false);
        setSelectedPermissions([]);
    };

    const handleNewDivisionChange = (e) => setNewDivision(e.target.value);

    const handleAddDivision = async () => {
        if (!newDivision.trim()) return;

        try {
            const payload = { name: newDivision };
            await axios.post('/api/divisions/', payload);
            setNewDivision('');
            handleCloseDivisionModal();
            fetchDivisions();
        } catch (error) {
            console.error('Erro ao adicionar divisão:', error);
        }
    };

    const handlePermissionToggle = (userId) => {
        const existingPermission = selectedPermissions.find(
            (permission) => permission.user_id === userId
        );

        if (existingPermission) {
            setSelectedPermissions(
                selectedPermissions.map((permission) =>
                    permission.user_id === userId
                        ? { ...permission, can_manage: !permission.can_manage }
                        : permission
                )
            );
        } else {
            setSelectedPermissions([
                ...selectedPermissions,
                { user_id: userId, can_manage: true },
            ]);
        }
    };

    const fetchPermissions = async (divisionId) => {
        try {
            const response = await axios.get(`/api/permissions/?division_id=${divisionId}`);
            if (response.data && Array.isArray(response.data)) {
                setPermissions(response.data);
            } else {
                console.error('Formato inválido de dados de permissões:', response.data);
            }
        } catch (error) {
            console.error('Erro ao buscar permissões:', error);
        }
    };

    const handleSavePermissions = async () => {
        if (!selectedDivision) return;
    
        try {
            // Adicionar permissões
            for (const permission of selectedPermissions) {
                if (!permission.id) { // Nova permissão (sem ID)
                    const payload = {
                        division_id: selectedDivision.id,
                        empregado_id: permission.user_id,
                        can_manage: permission.can_manage,
                    };
                    console.log('Payload para criação:', payload); // Adicionar log do payload
                    await axios.post('/api/permissions/', payload);
                }
            }
    
            // Remover permissões que não estão mais selecionadas
            for (const permission of permissions) {
                if (!selectedPermissions.some((p) => p.id === permission.id)) {
                    console.log('Removendo permissão com ID:', permission.id); // Adicionar log
                    await axios.delete(`/api/permissions/${permission.id}/`);
                }
            }
    
            fetchPermissions(selectedDivision.id); // Atualiza permissões
            handleClosePermissionsModal(); // Fecha o modal
        } catch (error) {
            console.error('Erro ao salvar permissões:', error);
            if (error.response) {
                console.error('Resposta do servidor:', error.response.data); // Mostrar resposta do servidor
            }
        }
    };

    const handleCloseAddDivisionModal = () => {
        setOpenAddDivisionModal(false);
    };
    

    return (
        <DashboardLayout>
            <Box sx={{ display: 'flex', flexDirection: 'column', p: 3 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h5">Divisões</Typography>
                    {user.seccao === 'Admin' && (
                        <IconButton color="primary" onClick={() => setOpenAddDivisionModal(true)}>
                        <FaPlus />
                    </IconButton>                    
                    )}
                </Box>

                <Paper sx={{ p: 3, mb: 3 }}>
                    <Typography variant="h6">Lista de Divisões</Typography>
                    <List>
                        {divisions.length > 0 ? (
                            divisions.map((division) => (
                                <ListItem 
                                    button 
                                    key={division.id} 
                                    onClick={() => handleOpenDivisionModal(division)}
                                >
                                    <ListItemText primary={division.name} />
                                    {user.seccao === 'Admin' && (
                                        <Box>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleOpenPermissionsModal(division)}
                                                sx={{ marginRight: 1 }}
                                            >
                                                Editar Permissões
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => handleDeleteDivision(division.id)}
                                            >
                                                Apagar Divisão
                                            </Button>
                                        </Box>
                                    )}
                                </ListItem>
                            ))
                        ) : (
                            <Typography>Nenhuma divisão encontrada.</Typography>
                        )}
                    </List>
                </Paper>

                <Modal open={openDivisionModal} onClose={() => setOpenDivisionModal(false)}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 500,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>Dispositivos e Integrações de {selectedDivision?.name}</Typography>

                        <Box>
                            <Typography variant="subtitle1" gutterBottom>Dispositivos</Typography>
                            {devices.length > 0 ? (
                                <List>
                                    {devices.map((device) => (
                                        <ListItem key={device.id} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Box>
                                                <Typography>{device.friendly_name || device.entity_id}</Typography>
                                                <Typography variant="body2">Estado: {device.state}</Typography>
                                            </Box>
                                            {device.entity_id.startsWith('switch.') && (
                                                <Button
                                                    variant="contained"
                                                    color={device.state === 'on' ? 'success' : 'error'}
                                                    onClick={() => toggleDeviceState(device)}
                                                >
                                                    {device.state === 'on' ? 'Desligar' : 'Ligar'}
                                                </Button>
                                            )}
                                        </ListItem>
                                    ))}
                                </List>
                            ) : (
                                <Typography>Nenhum dispositivo encontrado.</Typography>
                            )}
                        </Box>
                        <Box>
                            {user.seccao === 'Admin' && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{ mt: 2 }}
                                    onClick={() => {
                                        fetchHomeAssistantDevices();
                                        setOpenAddDeviceModal(true);
                                    }}
                                
                                >
                                    + Adicionar Dispositivo
                                </Button>
                            )}
                        </Box>

                        <Box sx={{ mt: 3 }}>
                            <Typography variant="subtitle1" gutterBottom>Integrações</Typography>
                            {integrations.length > 0 ? (
                                <List>
                                    {integrations.map((integration, index) => (
                                        <Box key={integration.id}>
                                            <ListItem
                                                button
                                                onClick={() => {
                                                    const updated = [...integrations];
                                                    updated[index].expanded = !updated[index].expanded;
                                                    setIntegrations(updated);
                                                }}
                                            >
                                                <ListItemText primary={integration.name} />
                                            </ListItem>
                                            {integration.expanded && (
                                                <Box sx={{ p: 2, bgcolor: 'background.default', borderRadius: 2 }}>
                                                    <Typography>Configurações:</Typography>
                                                    <pre>{JSON.stringify(integration.config, null, 2)}</pre>
                                                </Box>
                                            )}
                                        </Box>
                                    ))}
                                </List>
                            ) : (
                                <Typography>Nenhuma integração encontrada.</Typography>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2 }}
                                onClick={() => setOpenAddIntegrationModal(true)}
                            >
                                + Adicionar Integração
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                <Modal open={openAddIntegrationModal} onClose={() => setOpenAddIntegrationModal(false)}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 500,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>Adicionar Integração</Typography>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel>Tipo de Integração</InputLabel>
                            <Select
                                value={selectedIntegrationType}
                                onChange={(e) => setSelectedIntegrationType(e.target.value)}
                            >
                                <MenuItem value="toggle_device">Ligar/Desligar Dispositivo</MenuItem>
                            </Select>
                        </FormControl>

                        {selectedIntegrationType === 'toggle_device' && (
                            <Box sx={{ mt: 3 }}>
                                <Typography>Selecionar Dispositivo:</Typography>
                                <FormControl fullWidth sx={{ mt: 2 }}>
                                    <InputLabel>Dispositivo</InputLabel>
                                    <Select
                                        value={selectedDevice}
                                        onChange={(e) => setSelectedDevice(e.target.value)}
                                    >
                                        {devices.map((device) => (
                                            <MenuItem key={device.id} value={device}>
                                                {device.friendly_name || device.entity_id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <Typography sx={{ mt: 3 }}>Selecionar dias da semana:</Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                    {['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB', 'DOM'].map((day) => (
                                        <Box
                                            key={day}
                                            sx={{
                                                cursor: 'pointer',
                                                width: 40,
                                                height: 40,
                                                borderRadius: '50%',
                                                bgcolor: selectedDays.includes(day) ? 'primary.main' : 'grey.300',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            onClick={() => {
                                                if (selectedDays.includes(day)) {
                                                    setSelectedDays(selectedDays.filter((d) => d !== day));
                                                } else {
                                                    setSelectedDays([...selectedDays, day]);
                                                }
                                            }}
                                        >
                                            <Typography>{day}</Typography>
                                        </Box>
                                    ))}
                                </Box>

                                <Box sx={{ mt: 2 }}>
                                    <TextField
                                        label="Hora de Ligar"
                                        type="time"
                                        fullWidth
                                        value={toggleOnTime}
                                        onChange={(e) => setToggleOnTime(e.target.value)}
                                        sx={{ mt: 2 }}
                                    />
                                    <TextField
                                        label="Hora de Desligar"
                                        type="time"
                                        fullWidth
                                        value={toggleOffTime}
                                        onChange={(e) => setToggleOffTime(e.target.value)}
                                        sx={{ mt: 2 }}
                                    />
                                </Box>
                            </Box>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ mt: 3 }}
                            onClick={handleSaveIntegration}
                            disabled={!selectedDevice || selectedDays.length === 0 || !toggleOnTime || !toggleOffTime}
                        >
                            Guardar Integração
                        </Button>
                    </Box>
                </Modal>

                {/* Modal para Selecionar Dispositivo */}
        <Modal open={openAddDeviceModal} onClose={() => setOpenAddDeviceModal(false)}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    maxHeight: '80%',
                    overflowY: 'auto',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <Typography variant="h6" gutterBottom>Selecione um Dispositivo</Typography>

                {homeAssistantDevices.length > 0 ? (
                    <List>
                        {homeAssistantDevices.map((device) => (
                            <ListItem
                                key={device.entity_id}
                                button
                                onClick={() => setSelectedDevice(device)}
                                selected={selectedDevice?.entity_id === device.entity_id}
                            >
                                <ListItemText
                                    primary={device.attributes.friendly_name || device.entity_id}
                                    secondary={`Estado: ${device.state}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Typography>Nenhum dispositivo encontrado.</Typography>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="contained" color="primary" onClick={handleAddDevice} disabled={!selectedDevice}>
                        Adicionar
                    </Button>
                </Box>
            </Box>
        </Modal>

                {/* Modal para Criar Divisão */}
                <Modal open={openAddDivisionModal} onClose={handleCloseAddDivisionModal}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 400,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>Adicionar Nova Divisão</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Nome da Divisão"
                                    value={newDivision}
                                    onChange={handleNewDivisionChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" onClick={handleAddDivision}>
                                    Adicionar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>

                {/* Modal para Editar Permissões */}
                <Modal open={openPermissionsModal} onClose={handleClosePermissionsModal}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 400,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>Permissões para {selectedDivision?.name}</Typography>
                        <Box
                            sx={{
                                maxHeight: 300,
                                overflowY: 'auto',
                                mt: 2,
                                border: '1px solid #ccc',
                                borderRadius: 2,
                                p: 2,
                            }}
                        >
                            {users.map((user) => (
                                <Box key={user.id} display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>{user.nome_completo}</Typography>
                                    <Checkbox
                                        checked={selectedPermissions.some(
                                            (permission) => permission.user_id === user.id && permission.can_manage
                                        )}
                                        onChange={() => handlePermissionToggle(user.id)}
                                    />
                                </Box>
                            ))}
                        </Box>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" onClick={handleSavePermissions}>
                                    Salvar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            </Box>
        </DashboardLayout>
    );
};

export default Home;
